/*
 *
 * SettingsAlertPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 24-Apr-2025
*/

import SettingsAlertPopup from './SettingsAlertPopupContainer'

export default SettingsAlertPopup
